module.exports = __webpack_public_path__ + "img/2023_1.42dde937.webp";